import AOS from 'aos';
import Bulider from "./components/bulider";
import Header from "./components/header";
import Form from "./components/form";

document.addEventListener("DOMContentLoaded", function () {
    AOS.init();
    new Header();
    new Bulider();
    new Form();

});